import $ from 'jquery';

/**
 * Class representing a Sector Modal.
 */
export default class SectorModal {
	/**
	 * Get selectors.
	 *
	 * @return {Object} Selectors.
	 */
	getSelectors() {
		return {
			rollover: '.sector-modal__rollover-item',
			description: '.sector-modal__content-wrapper',
		};
	}

	/**
	 * Construct a new SectorModal instance.
	 */
	constructor() {
		this.bindUiActions();
	}

	/**
	 * Bind UI actions.
	 */
	bindUiActions() {
		const selectors = this.getSelectors();
		$(selectors.rollover).on('mouseenter mouseleave', this.toggleActiveState.bind(this));
		$(selectors.description).on('mouseenter mouseleave', this.toggleActiveState.bind(this));
		$(selectors.rollover).on('click', this.goToPage.bind(this));
	}

	/**
	 * Toggle the active state.
	 *
	 * @param {jQuery.Event} e The jQuery event.
	 */
	toggleActiveState(e) {
		const selectors = this.getSelectors();
		const sector = $(e.currentTarget).data('sector');
		$(`${selectors.rollover}[data-sector="${sector}"]`).toggleClass('is-active');
		$(`${selectors.description}[data-sector="${sector}"]`).toggleClass('is-active');
	}

	/**
	 * Go to sector page.
	 *
	 * @param {jQuery.Event} e The jQuery event.
	 */
	goToPage(e) {
		const selectors = this.getSelectors();
		const sector = $(e.currentTarget).data('sector');
		const href = $(`${selectors.description}[data-sector="${sector}"]`).attr('href');
		if (href) {
			window.location.href = href;
		}
	}
}
